import * as lib from 'Root/lib/lib.js'

class Modal {
    constructor(element) {
        if (!element) return

        this.element = element

        this._iniActions()
    }

    _iniActions() {
        this.element.querySelector('.s-modal__close').addEventListener('click', () => {
            this.close()
        })

        $(this.element).on('click', (e) => {
            if (!$(e.target).closest('.s-modal__cont').length) {
                this.close()
            }
        })

        document.addEventListener('keyup', (e) => {
            if (e.key === 'Escape') {
                this.close()
            }
        })
    }

    close() {
        $(this.element).fadeOut()
        lib.enableBodyScroll()
    }

    open() {
        $(this.element).fadeIn()
        this.element.querySelector('.s-modal__box__cont').scrollTo(0, 0)
        lib.disableBodyScroll()
    }
}

export default Modal
